import React, { useEffect, useRef } from 'react';

// The "right account?" check (lib/accountIdle). Raised by a write to an open
// account nobody has touched for IDLE_MS; the write waits on the answer.
//
// The confirm button names the account rather than saying "OK", and is not
// focused on open: the keypress that triggered the write (Enter in a form)
// must not be able to answer it too.
export default function AccountConfirmModal({ name, number, color, idleMs, onConfirm, onCancel }) {
  const boxRef = useRef(null);
  useEffect(() => { boxRef.current?.focus(); }, []);
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onCancel(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onCancel]);

  const minutes = Number.isFinite(idleMs) ? Math.max(1, Math.round(idleMs / 60000)) : null;
  const label = name || (number ? `#${number}` : 'this account');

  return (
    <div className="confirm-acct-backdrop" onClick={onCancel}>
      <div
        ref={boxRef}
        className="confirm-acct"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="confirm-acct-title"
        tabIndex={-1}
        style={{ '--acct': color }}
        onClick={e => e.stopPropagation()}
      >
        <div id="confirm-acct-title" className="confirm-acct-title">Is this the right account?</div>
        <div className="confirm-acct-card">
          <span className="confirm-acct-avatar">{(name || '#').trim().charAt(0).toUpperCase()}</span>
          <span className="confirm-acct-text">
            <span className="confirm-acct-name">{label}</span>
            {name && number && <span className="confirm-acct-num">#{number}</span>}
          </span>
        </div>
        <div className="confirm-acct-why">
          {minutes ? `Nobody has worked in this account for ${minutes} min. ` : ''}
          Check it is the customer you mean before the change goes through.
        </div>
        <button className="confirm-acct-yes" onClick={onConfirm}>Yes, change {label}</button>
        <button className="confirm-acct-no" onClick={onCancel}>Cancel, change nothing</button>
      </div>
    </div>
  );
}
